import { createNode } from '@glueapp/graph-types';
import { DataValue } from '@glueapp/graph-types';

export const SortListAlphabetically = createNode({
    id: 'Sort List Alphabetically',
    name: 'Sort List Alphabetically',
    description: 'Sorts a list of texts alphabetically, Example: [Peter, Abed, Berta, Albert] becomes [Abed, Albert, Berta, Peter]',
    aiDescription:
        'Sorts a list of strings alphabetically. Connect "List" (array of string) and set "Order" to "Ascending" or "Descending". Output: "Sorted List".',
    category: 'List',
    color: '#778ed5',
    integration: undefined,
    inPorts: {
        List: {
            kind: 'array',
            subType: {
                kind: 'string',
            },
        },
        Order: {
            kind: 'union',
            subTypes: [
                { kind: 'stringLiteral', stringLiteral: 'Ascending' },
                { kind: 'stringLiteral', stringLiteral: 'Descending' },
            ],
        },
    },
    outPorts: {
        'Sorted List': {
            kind: 'array',
            subType: {
                kind: 'string',
            },
        },
    },
    execute: function (input) {
        const inputArray = input.inPorts.List;
        const order = input.inPorts.Order;
        let sortedArray;
        switch (order) {
            case 'Ascending':
                sortedArray = Array.from(inputArray).sort();
                break;
            case 'Descending':
                sortedArray = Array.from(inputArray).sort().reverse();
                break;
        }
        return { output: { 'Sorted List': sortedArray as DataValue[] } };
    },
});
